import {gql} from '@apollo/client';

export const NotificationUpdates = gql`
    query NotificationUpdates {
        me {
            notifications {
                unseen
                userContextCounts {
                    unseen
                    userContext {
                        id
                    }
                }
            }
            conversations {
                inbox {
                    total {
                        all
                        own
                        star
                    }
                    unseen {
                        all
                        own
                        star
                    }
                }
                userContextCounts {
                    inbox {
                        # We are interested in the "own" and "star" counts as these are the ones used to determine
                        # the badge displayed on the conversation icon in the top bar.
                        unseen {
                            own
                            star
                        }
                    }
                    userContext {
                        id
                    }
                }
            }
        }
    }
`;
